import { Wrapper } from '~/components/dialogs/Wrapper'
import { Contact } from '~/components/Contact'

export const Failure = () => {
  return (
    <Wrapper>
      <FailureContent />
    </Wrapper>
  )
}

export const FailureContent = ({ close }) => {
  return (
    <>
      <div className="mb-2 pb-4 text-2xl font-semibold text-[#666666]">
        There was an issue processing your decision.
      </div>
      <div className="leading-7 text-[#333333]">
        <p className="pb-4">Please review your personal information and try again.</p>
        <p className="pb-4">
          If you continue to experience issues,&nbsp; <Contact />
        </p>
      </div>
      <div className="float-right">
        <button
          type="button"
          className="rounded-full bg-primary-blue px-6 py-2 text-2xl text-slate-50 transition-colors duration-300 hover:bg-[#2a60de]"
          onClick={close}
        >
          Try Again &gt;
        </button>
      </div>
    </>
  )
}
